export const EARNINGS_PAGE_SIZE_DEFAULT = 100
export const EARNING_PAGE_TO_DEFAULT = new Date()
export const EARNING_DEFAULT_RANGE = 'week'
export const EARNING_PAGE_FROM_DEFAULT =
  EARNING_DEFAULT_RANGE === 'week'
    ? new Date(new Date().setDate(EARNING_PAGE_TO_DEFAULT.getDate() - 7))
    : new Date(new Date().setFullYear(EARNING_PAGE_TO_DEFAULT.getFullYear() - 1))
export const EARNING_DATEPICKER_YEAR_AVAILABLE = true
